import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconRestore = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.271 3.19a10 10 0 1 1-5.205 9.921 1 1 0 0 1 1.988-.222A8 8 0 1 0 5.075 8H8a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1v-5a1 1 0 1 1 2 0v2.004a10 10 0 0 1 3.271-2.814m3.315 7.396a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828"
            clipRule="evenodd"
        />
    </svg>
);
